// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"Layout_MainContainer__1lPcB","Main":"Layout_Main__18kKW"};